export function summarizationError(error) {
  const detail = error.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) return "Check the YouTube URL and selected options, then retry.";
  if (error.code === "ECONNABORTED" || error.code === "ETIMEDOUT") {
    return "Processing took too long. Check History before retrying; the summary may still finish.";
  }
  if (!error.response) return "Could not reach the API. The Render service may be waking up; retry shortly.";
  if (error.response.status === 401) return "Your session expired. Sign in again to summarize.";
  if ([502, 503, 504].includes(error.response.status)) {
    return "The backend is temporarily unavailable. It may be waking up; retry shortly.";
  }
  return "Could not process this video. Please retry or try another video.";
}
